import * as React from 'react';
const TextEditCore = (props) => {
    const { buttonProps, components: { Button, Grid, GridColumn }, } = props;
    return (React.createElement(Grid, { noWrap: true, align: ['middle-xs'], gutter: "small" },
        React.createElement(GridColumn, { width: ['minmax'] }, props.children),
        React.createElement(GridColumn, { width: ['min'] },
            React.createElement(Button, Object.assign({ type: "text-color", link: true, icon: "#edit", iconSize: "xs" }, buttonProps, { text: props.buttonText, onClick: props.onClick })))));
};
export default TextEditCore;
